import { z } from 'zod';
import { Channel } from './notification.schema';

export const providerConfigSchema = z.object({
  id: z.string(),
  channel: Channel,
  providerId: z.string(),
  priority: z.number(),
  isEnabled: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ProviderConfig = z.infer<typeof providerConfigSchema>;

export const providerConfigInputSchema = z.object({
  channel: Channel,
  providerId: z.string().min(1, 'Provider ID is required'),
  priority: z.number().int().positive('Priority must be at least 1'),
  isEnabled: z.boolean().optional(),
});
export type ProviderConfigInput = z.infer<typeof providerConfigInputSchema>;
